
import VideoTime from "../../../assets/outline/VideoTime.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoTimeIcon({ className, dataTestid = "VideoTimeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VideoTime data-testid={dataTestid} className={classes} {...rest} />
  );
}
